import React, {Component} from 'react';
import PropTypes from 'prop-types';

import * as d3 from 'd3';
import _ from 'lodash';

class HeatMapShapes extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    const sizeDifferent = nextProps.cellSize !== this.props.cellSize;
    const yearDiff = nextProps.year !== this.props.year;
    const dimsDiff = nextProps.dimensions !== this.props.dimensions;
    const sortDiff = nextProps.sortField !== this.props.sortField;
    const pageDiff = nextProps.page !== this.props.page;
    const sizeDiff = nextProps.size !== this.props.size;

    return sizeDifferent || yearDiff || dimsDiff || sortDiff || pageDiff || sizeDiff;
  }

  render() {
    const props = this.props;

    const cellSize = this.props.cellSize;
    const year = this.props.year;
    const yearIndex = 2015 - (year || 2015);

    const colors = ['#1b1b1b', '#3d1c3d', '#6e246e', '#a520a5', '#e00de0'];
    const colorScale = d3.scaleQuantile()
      .domain([0, 50, 75, 90, 100])
      .range(colors);

    const cellsData = _.reduce(this.props.data || [], (reducer, row, ri) => {
      _.forEach(this.props.dimensions, (d, di) => {
        const fips = _.get(row, props.dimId);

        reducer.push({
          cn: row.cn,
          sn: row.sn,
          sa: row.sa,
          year: year,
          row: ri,
          col: di,
          data: row,
          dimension: d,
          fips: fips,
          raw: _.get(props, ['dict', fips, d.field, yearIndex], 0),
          value: _.get(row, [d.field, yearIndex], 0)
        })
      });

      return reducer;
    }, []);

    return (
      <g>
        {_.map(cellsData, (d, i) => {
          return (
            <rect
              key={`${d.row}:${d.col}`}
              x={d.col * cellSize}
              y={d.row * cellSize}
              rx={2}
              ry={2}
              className={"cell cell-border cr" + (d.row) + " cc" + (d.col - 1)}
              width={cellSize}
              height={cellSize}
              fill={colorScale(d.value)}
              onMouseEnter={() => {
                if (props.onHoverOver) {
                  const coords = [d.col * cellSize + cellSize / 2, d.row * cellSize + cellSize / 2];
                  const content = (
                    <div>
                      <div className="dim-hover">{d.dimension.desc}</div>
                      <b className="purple">Percentile : </b><i>{d.value}</i><br/>
                      <b>Value : </b><i>{d3.format(',')(d.raw)}</i>
                    </div>
                  );
                  const data = {
                    ...d.data,
                    year: d.year,
                    content
                  };
                  const p = {};

                  props.onHoverOver(d.fips, {coords, props: p, data: data}, d.row, d.col)
                }
              }}
              onMouseLeave={() => {
                if (props.onHoverOut) {
                  props.onHoverOut(d.fips)
                }
              }}
              onClick={event => {
                event.persist();
                if (props.onClick) {
                  props.onClick(d.fips, d.dimension.field, event.shiftKey);
                }
              }}
            >
            </rect>
          )
        })}
      </g>
    )
  }
}

HeatMapShapes.propTypes = {
  onClick: PropTypes.func,
  onHover: PropTypes.func,
  data: PropTypes.array,
  dimensions: PropTypes.array,
  dimId: PropTypes.string,
  year: PropTypes.number,
  cellSize: PropTypes.number
};

export default HeatMapShapes


// WEBPACK FOOTER //
// ./src/charts/HeatMap/HeatMapShapes.js